import React, { useState, useEffect, useMemo, useRef } from "react";
import HBIcon from "@/components/HBIcon";
import styles from "./index.module.less";
import HBButtonGroup from "@/components/HBButtonGroup";
import { Button, Dropdown, Menu } from "antd";
import HBMessage from "@/components/HBMessage";
import { button_click } from "@/tracker/collecter/buttonClick";
import PluginModal from "../PluginModal";
export const checkBrowser = (pluginList, navigator) => {
  if (!navigator) {
    return {};
  }

  const userAgent = navigator.userAgent;
  const is360 = userAgent.indexOf("360SE") > -1; //判断是否360浏览器
  const is360fast = userAgent.indexOf("360EE") > -1; //判断是否360极速版浏览器
  const isQQ = userAgent.indexOf("QQBrowser") > -1; // 判断是否QQ浏览器
  const isSougou = userAgent.indexOf("MetaSr") > 1; // 判断是否搜狗浏览器
  const isFirefox = userAgent.indexOf("Firefox") > -1; //判断是否Firefox浏览器
  // const isUC = userAgent.indexOf("UBrowser") > -1; //判断是否UC浏览器
  const isIE =
    userAgent.indexOf("IE") > -1 || userAgent.indexOf("Trident") > -1; //判断是否IE浏览器
  const isEdge = userAgent.indexOf("Edg") > -1; //判断是否Edge浏览器
  const isSafari =
    userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") === -1; // 判断是否safari
  const pluginMap = pluginList.reduce((result, item) => {
    result[item.value] = item;
    return result;
  }, {});
  let plugin = pluginMap["chrome"];
  if (is360) {
    plugin = pluginMap["360"];
  } else if (is360fast) {
    plugin = pluginMap["360fast"];
  } else if (isQQ) {
    plugin = pluginMap["qq"];
  } else if (isSougou) {
    plugin = pluginMap["sougou"];
  } else if (isFirefox) {
    plugin = pluginMap["firefox"];
  } else if (isEdge) {
    plugin = pluginMap["edge"];
  } else if (isSafari) {
    plugin = pluginMap["safari"];
  }
  return plugin;
  // return pluginMap["sougou"]
};
export default function PluginButton(props) {
  const { pluginList, problemHref } = props;
  const [isWall, setIsWall] = useState(true);
  const [plugin, setPlugin] = useState(null);
  const downloadBtn = useRef(null);
  const [visable, setVisable] = useState(false);
  const [activeKey, setActiveKey] = useState();
  useEffect(() => {
    // 用一张翻墙的图判断是否翻墙，setTimeout为了避免浏览器转圈圈
    const img = document.createElement("img");
    img.style = "display: none";
    img.src = "//www.google.com/images/icons/product/chrome_web_store-32.png";
    img.onload = () => {
      setIsWall(false);
    };
    setTimeout(() => {
      img.onload = () => {};
      img.src = "//st0.dancf.com/static/02/202201151128-a455.svg";
      document.body.removeChild(img);
    }, 5000);
    document.body.appendChild(img);
  }, []);
  const menu = useMemo(() => {
    const download = (e, plugin) => {
      const { appStoreUrl, href } = plugin;
      e.preventDefault();
      if (!appStoreUrl && !href) {
        HBMessage.info("即将上线 敬请期待");
        return;
      }
      // window.location.href = !isWall && !!wallHref ? wallHref : href[0].url;
      button_click(e.target, navigator.userAgent);
      //  如果有应用商店地址，且不是谷歌浏览器，或者用户翻墙了，且为谷歌浏览器，则跳应用商店
      if (
        !!appStoreUrl &&
        (plugin.value !== "chrome" || (!isWall && plugin.value === "chrome"))
      ) {
        window.open(appStoreUrl);
        return;
      }
      // 360 和360fast 展示同一个弹窗
      if (plugin.value == "360fast") {
        setActiveKey("360");
      } else {
        setActiveKey(plugin.value);
      }
      setVisable(true);
    };
    return (
      <Menu className={styles.menu}>
        {pluginList.map((plugin, index) => {
          const { label, logo, href, appStoreUrl } = plugin;
          return (
            <Menu.Item key={index}>
              <a
                className={styles.link}
                href={appStoreUrl ? appStoreUrl : ""}
                onClick={(e) => {
                  download(e, plugin);
                }}
                data-button-name={`${label}安装包`}
              >
                <div className={styles.logo}>
                  <img src={logo} alt={label} />
                </div>
                <div className={styles.text}>{label}</div>
              </a>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  }, [pluginList]);

  useEffect(() => {
    let plugin = checkBrowser(pluginList, navigator);
    setPlugin(plugin);
  }, [pluginList]);

  const onClick = () => {
    const { appStoreUrl, href } = plugin;
    if (!appStoreUrl && !href) {
      HBMessage.info("即将上线 敬请期待");
      return;
    }
    button_click(downloadBtn.current, navigator.userAgent);
    //  如果有应用商店地址，且不是谷歌浏览器，或者用户翻墙了，且为谷歌浏览器，则跳应用商店
    if (
      !!appStoreUrl &&
      (plugin.value !== "chrome" || (!isWall && plugin.value === "chrome"))
    ) {
      window.open(appStoreUrl);
      return;
    }
    // 360 和360fast 展示同一个弹窗
    if (plugin.value == "360fast") {
      setActiveKey("360");
    } else {
      setActiveKey(plugin.value);
    }
    setVisable(true);
  };

  return (
    <>
      <HBButtonGroup className={styles.buttonGroup}>
        <Button
          className={styles.download}
          type="primary"
          data-button-name={`${plugin?.label}安装包`}
          onClick={onClick}
          ref={downloadBtn}
        >
          安装{plugin?.label}插件
        </Button>
        <Dropdown overlay={menu} trigger="hover" placement="bottomRight">
          <Button className={styles.more} type="primary">
            <HBIcon className={styles.icon} type="ic_arrow_down" />
          </Button>
        </Dropdown>
      </HBButtonGroup>
      <PluginModal
        visable={visable}
        setVisable={setVisable}
        activeKey={activeKey}
        setActiveKey={setActiveKey}
        pluginList={pluginList}
        problemHref={problemHref}
      ></PluginModal>
    </>
  );
}
